module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "e241b3d",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
